export * from '../../core/config';

import { config } from '../../core/config';

// @ts-ignore
config._renderlet = null; // type (group:string) => void
